import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ClientSearchProvider } from '@brightnav/ui';
import { BrightNavOmniSearchRegistry } from '@brighthub/brightnav-registry';
import { ConversationSearchProvider } from '@brighthub/brightnav-conversation-search';
import { EmployeeSearchProvider } from '@brighthub/brightnav-employee-search';

import { RouterOutlet } from '@angular/router';

/**
 * Top-level BrightNav router host. Wraps the primary outlet in a full-height flex column so lazy
 * children (including admin) can stretch to the available route area.
 *
 * @remarks The activated route host is a flex **column** (`flex-col`), not the default row, so a
 * single root (e.g. `bn-my-clients-route` → `bn-my-clients-layout`) gets full **width** via
 * `align-items: stretch` instead of shrinking to content on the main axis.
 */
@Component({
  selector: 'bn-brightnav-shell',
  imports: [
    RouterOutlet
],
  templateUrl: './brightnav-shell.component.html',
  styleUrl: './brightnav-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ClientSearchProvider,
    ConversationSearchProvider,
    EmployeeSearchProvider,
  ],
})
export class BrightnavShellComponent {
  brightNavOmniSearchRegistry = inject(BrightNavOmniSearchRegistry);

  constructor() {
    this.brightNavOmniSearchRegistry.registerProviders();
  }
}
